import React from 'react';

import { useListStyles as useStylesheet } from './stylesheets';
import { RecursiveShortcodeProps } from './Shortcode';

const OrderedList = ({ RecursiveShortcode, elements, ...rest }: RecursiveShortcodeProps) => {
  const { against, attributes, layout } = rest;
  const { styles } = useStylesheet({
    layout,
    against,
    attributes,
  });
  return (
    <ol style={styles.root}>
      {/* @ts-ignore: error when upgrading to @ux/config */}
      <RecursiveShortcode elements={elements} nl2br={false} {...rest} />
    </ol>
  );
};

OrderedList.displayName = 'OrderedList';

export default OrderedList;
